var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS4 = function SvgS4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M12.74 20.03h4.782m-4.782-6.37h4.782m-13.043-.433.87 1.735 2.173-2.603M4.479 18.44l2.173 3.044m0-3.044L4.48 21.484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.957 3.67A3.26 3.26 0 0 1 21 6.925v17.01a3.26 3.26 0 0 1-3.26 3.262H4.26A3.26 3.26 0 0 1 1 23.935V6.924A3.26 3.26 0 0 1 4.043 3.67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M5.673 6.272h10.653c.9 0 1.63-.73 1.63-1.63V2.63c0-.9-.73-1.63-1.63-1.63H5.673c-.9 0-1.63.73-1.63 1.63v2.01c0 .9.73 1.63 1.63 1.63"
  })));
};
export default SvgS4;